import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import httpMethod from 'services/update2025/httpMethod';

import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";

import { RegisterContext } from "components/account-register/RegisterContext";
import { findDivisionById } from "services/DivisionService";
import { Button } from "primereact/button";

export const RegisterEditor = () => {
    const toast = useRef(null);
    const { t, i18n } = useTranslation(["account-register", "common"]);
    const tokenObj = httpMethod.getTokenStorage(); // { access_token, … }
    const accessToken = tokenObj?.access_token;;

    let headers = {
        Authorization: `Bearer ${accessToken}`,
        "Accept-Language": i18n.language,
    };

    const registerContext = useContext(RegisterContext);
    const { register, setRegister, registerDialog, setRegisterDialog } = registerContext;

    const [permanentAddress, setPermanentAddress] = useState(null);

    useEffect(() => {
        if (register) {
            let provincePromise = findDivisionById(headers, register?.provinceId);
            let districtPromise = findDivisionById(headers, register?.districtId);
            let wardPromise = findDivisionById(headers, register?.wardId);

            Promise.all([provincePromise, districtPromise, wardPromise]).then((values) => {
                const province = values[0]?.data?.name;
                const district = values[1]?.data?.name;
                const ward = values[2]?.data?.name;

                setPermanentAddress(`${register.addressLine}, ${ward}, ${district}, ${province}`);
            });
        }
    }, [register]);

    const genders = [
        { label: t("male", { ns: "common" }), value: "1" },
        { label: t("female", { ns: "common" }), value: "0" },
    ];

    const states = [
        { label: t("registering"), value: "REGISTERING" },
        { label: t("otp.verified"), value: "OTP_VERIFIED" },
        { label: t("expired"), value: "EXPIRED" },
        { label: t("completed"), value: "COMPLETED" },
    ];

    const hideDialog = () => {
        setRegisterDialog(false);
    };

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={registerDialog} style={{ width: "70%" }} header={t("register.titleDetail")?.toUpperCase()} modal className="p-fluid text-center" onHide={hideDialog}>
                <div className="formgrid">
                    <div className=" grid text-left">
                        <div className="col-12">
                            <div className="grid">
                                {/* số cccd */}
                                <div className="field col-12 md:col-3">
                                    <label style={{ fontWeight: "500" }} htmlFor="idNumber">
                                        {t("idNumber")}
                                    </label>
                                    <InputText id="idNumber" value={register?.idNumber} readOnly />
                                </div>

                                {/* số điện thoại */}
                                <div className="field col-12 md:col-3">
                                    <label style={{ fontWeight: "500" }} htmlFor="phoneNumber">
                                        {t("phoneNumber")}
                                    </label>
                                    <InputText id="phoneNumber" value={register?.phoneNumber} readOnly />
                                </div>

                                {/* trạng thái */}
                                <div className="field col-12 md:col-3">
                                    <label style={{ fontWeight: "500" }} htmlFor="state">
                                        {t("state")}
                                    </label>
                                    <InputText id="state" value={states.find((g) => g.value === register?.state)?.label} readOnly />
                                </div>
                            </div>

                            <div className="grid">
                                {/* họ và tên */}
                                <div className="field col-6">
                                    <label style={{ fontWeight: "500" }} htmlFor="fullName">
                                        {t("fullName")}
                                    </label>
                                    <InputText id="fullName" value={register?.fullName} readOnly />
                                </div>

                                {/* ngày sinh */}
                                <div className="field col-12 md:col-3">
                                    <label style={{ fontWeight: "500" }} htmlFor="birthdate">
                                        {t("birthdate")}
                                    </label>
                                    <InputText id="birthdate" value={register?.birthdate} readOnly />
                                </div>

                                {/* giới tính */}
                                <div className="field col-12 md:col-3">
                                    <label style={{ fontWeight: "500" }} htmlFor="gender">
                                        {t("gender")}
                                    </label>
                                    <InputText id="gender" value={genders.find((g) => g.value === `${register?.gender}`)?.label} readOnly />
                                </div>
                            </div>

                            <div className="grid">
                                {/* địa chỉ thường trú */}
                                <div className="field col-12">
                                    <label style={{ fontWeight: "500" }} htmlFor="permanentAddress">
                                        {t("permanentAddress")}
                                    </label>
                                    <InputTextarea id="permanentAddress" value={permanentAddress} readOnly rows={3} cols={20} />
                                </div>
                            </div>

                            <div className="grid">
                                {/* ngày hết hạn */}
                                <div className="field col-12 md:col-3">
                                    <label style={{ fontWeight: "500" }} htmlFor="expiredDate">
                                        {t("expiredDate", { ns: "common" })}
                                    </label>
                                    <InputText id="expiredDate" value={register?.expiredDate} readOnly />
                                </div>

                                {/* ngày tạo */}
                                <div className="field col-12 md:col-3">
                                    <label style={{ fontWeight: "500" }} htmlFor="createdDate">
                                        {t("createdDate", { ns: "common" })}
                                    </label>
                                    <InputText id="createdDate" value={register?.createdDate} readOnly />
                                </div>

                                {/* ngày sửa */}
                                <div className="field col-12 md:col-3">
                                    <label style={{ fontWeight: "500" }} htmlFor="modifiedDate">
                                        {t("modifiedDate", { ns: "common" })}
                                    </label>
                                    <InputText id="modifiedDate" value={register?.modifiedDate} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="grid">
                    <div className="col-12">
                        <Button
                            style={{
                                width: "max-content",
                            }}
                            label={t("close", { ns: "common" })}
                            icon="pi pi-times"
                            onClick={hideDialog}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
